export function isSafari(): boolean {
	if (typeof navigator === 'undefined') return false;

	const ua = navigator.userAgent;

	// True Safari has no CriOS (Chrome), no FxiOS (Firefox), and includes Safari
	const isSafariBrowser =
		ua.includes('Safari') && !ua.includes('CriOS') && !ua.includes('FxiOS');

	return isSafariBrowser;
}
